// import firebase from "firebase";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';
import { Landing } from 'thecodelife/Landing';
import { AdminLanding } from 'thecodelife/AdminLanding';
import { IDEWithProvider } from 'ide/IDE';
import { Authenticated } from 'components/auth/Authenticated';

// set up the style
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/style.scss';
import PyodideProvider from 'components/pyodide/PyodideProvider';
import { AssignmentViewer } from 'thecodelife/github/AssignmentViewer';
import { TeamPanel } from 'thecodelife/TeamPanel';
import { ZipEditor } from 'thecodelife/ZipEditor';

/*
 * This contains the broader route initialization.
 * If a route does not belong to a course, put it here.
 */
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path="/"
    >
      <Route index element={<Landing/>}/>

      <Route path="/admin" element={<AdminLanding/>}/>
      <Route path="/admin/zips" element={<ZipEditor/>}/>

      <Route path="/team" element={<TeamPanel/>}/>

      <Route
            path="ide/:urlFormat/:urlKey"
            element={
              <PyodideProvider>
                <Authenticated component={IDEWithProvider} />
              </PyodideProvider>
            }
        />
      <Route
        path="g/:urlKey"
        element={
          <AssignmentViewer />
        }
      />
        
    </Route>,
  ),
);

export const Router = () => {
  return <RouterProvider router={router} />;
};
